import { collection, query, getDocs, setDoc, doc, QueryDocumentSnapshot, DocumentData } from 'firebase/firestore';
import { db } from '../../../config/firebase';
import DbCollections from '../../../resources/enums/DbCollections';
import { AdditionalStage } from '../types';

const mapSnapshotToAdditionalStage = (doc: QueryDocumentSnapshot<DocumentData>) => {
    return {
        ...doc.data(),
        id: doc.id,
        publishFrom: doc.data().publishFrom ? doc.data().publishFrom.toDate() : null,
        publishTo: doc.data().publishTo ? doc.data().publishTo.toDate() : null,
    } as AdditionalStage;
};

const mapAdditionalStageToSnapshot = (additionalStage: AdditionalStage) => {
    return {
        ...additionalStage,
        additionalExercises: additionalStage.additionalExercises.filter((x) => x) ?? [],
        image: additionalStage.image ?? '',
        publishFrom: additionalStage.publishFrom ?? null,
        publishTo: additionalStage.publishTo ?? null,
    };
};

export const getAdditionalStagesFirebase = async () => {
    const querySnapshot = await getDocs(query(collection(db, DbCollections.AdditionalStages)));

    const additionalStages = [] as AdditionalStage[];
    querySnapshot.forEach(async (doc) => {
        additionalStages.push(mapSnapshotToAdditionalStage(doc));
    });

    return additionalStages;
};

export const saveAdditionalStageFirebase = async (additionalStage: AdditionalStage) => {
    await setDoc(
        doc(db, DbCollections.AdditionalStages, additionalStage.id),
        mapAdditionalStageToSnapshot(additionalStage),
    );
    return additionalStage;
};
